module.exports = __webpack_public_path__ + "img/content3.8945d296.png";